import { h } from 'preact'
import styled from 'styled-components'

const TooltipBubble = styled(
  ({
    children = null,
    height,
    width,
    offset = 0.5,
    className,
    topArrow = false,
  }) => (
    <div className={className}>
      {topArrow ? (
        <div
          style={{
            width: 10,
            height: 10,
            borderBottom: 'solid black 10px',
            borderRight: 'solid transparent 5px',
            borderLeft: 'solid transparent 5px',
            left: `${100 * offset}%`,
            position: 'absolute',
          }}
        />
      ) : null}
      {topArrow ? <div style={{ height: 10 }} /> : null}
      <div
        style={{
          padding: '10px 20px 10px 20px',
          borderRadius: 3,
          height,
          width,
          backgroundColor: '#222',
          opacity: 0.9,
          color: 'white',
        }}
      >
        {children}
      </div>
      {!topArrow ? (
        <div
          style={{
            width: 10,
            height: 10,
            borderTop: 'solid black 10px',
            borderRight: 'solid transparent 5px',
            borderLeft: 'solid transparent 5px',
            left: `${100 * offset}%`,
            position: 'absolute',
          }}
        />
      ) : null}
      {!topArrow ? <div style={{ height: 10 }} /> : null}
    </div>
  ),
)`
  margin-left: -5px;
  position: absolute;
  transform: translate(
    -${props => 100 * props.offset}%,
    ${props => (props.topArrow ? 0 : -100)}%
  );
  z-index: ${props => props.zIndex || 10};
`

export default TooltipBubble



// WEBPACK FOOTER //
// ./components/TooltipBubble.js